// @ngInject
const archiveConfig = ($stateProvider) => {
  $stateProvider.state('archive', {
    parent: 'main',
    url: '/archive',
    views: {
      'main-content': {
        controller: 'ArchiveController as vm',
        templateUrl: 'main/archive/archive.tpl.html',
      },
    },
    data: { pageTitle: 'Archive' },
  });

  $stateProvider.state('archive.entity', {
    url: '/:resource',
    data: { pageTitle: 'Archive' },
  });
};

class ArchiveController {
  constructor($scope, $state) {
    'ngInject';

    this.resource = $state.params.resource;
    $scope.$watch(
      () => $state.params.resource,
      (resource) => {
        this.resource = resource;
      },
    );
    $scope.$on('$stateChangeSuccess', () => {
      if ($state.is('archive')) {
        $scope.$applyAsync(() => {
          $state.go(
            'archive.entity',
            { resource: 'articletemplates' },
            {
              location: 'replace',
            },
          );
        });
      }
    });
  }
}

angular
  .module('main.archive', [])
  .config(archiveConfig)
  .controller('ArchiveController', ArchiveController);
